import styles from "./styles/style.module.css";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useState } from "react";
function InputField({
  placeholder,
  type = "text",
  required = false,
  seterVal,
  gaterVal,
  labelVal = false,
}) {
  const [show, setShow] = useState(false);
  const handleChange = (e) => {
    seterVal(e.target.value);
  };
  if (type === "password") {
    return (
      <>
        {labelVal && (
          <div style={{ marginBlock: "0.4rem" }}>
            <label className={styles.labelVal}>{labelVal}</label>
          </div>
        )}

        <div className={styles.passWrapper}>
          <input
            type={show ? "text" : "password"}
            placeholder={placeholder}
            className={styles.inputFieldForPass}
            style={{ width: "100%" }}
            value={gaterVal}
            onChange={handleChange}
            required={required}
          />
          <span
            onClick={() => setShow((pre) => !pre)}
            className={styles.eyeIcon}
          >
            {!show ? (
              <VisibilityOffIcon style={{ color: "gray" }} />
            ) : (
              <VisibilityIcon style={{ color: "#5A5A5A" }} />
            )}
          </span>
        </div>
      </>
    );
  }
  return (
    <>
      {labelVal && (
        <div style={{ marginBlock: "0.4rem" }}>
          <label className={styles.labelVal}>{labelVal}</label>
        </div>
      )}
      <input
        type={type}
        className={styles.inputField}
        style={{ width: "100%" }}
        placeholder={placeholder}
        value={gaterVal}
        onChange={handleChange}
        required={required}
      />
    </>
  );
}

export default InputField;
